/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInner } from './FindAllScreenerTags200ResponseDataInner';
import {
    FindAllScreenerTags200ResponseDataInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200Response
 */
export interface FindAllScreenerTags200Response {
    /**
     * 
     */
    data?: Array<FindAllScreenerTags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllScreenerTags200Response interface.
 */
export function instanceOfFindAllScreenerTags200Response(value: object): value is FindAllScreenerTags200Response {
    return true;
}

export function FindAllScreenerTags200ResponseFromJSON(json: any): FindAllScreenerTags200Response {
    return FindAllScreenerTags200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllScreenerTags200ResponseToJSON(json: any): FindAllScreenerTags200Response {
    return FindAllScreenerTags200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseToJSONTyped(value?: FindAllScreenerTags200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerToJSON)),
    };
}

